/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIGuestRequestFileSearchResult
 */
export interface APIGuestRequestFileSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFileSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestFileSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFileSearchResult
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFileSearchResult
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFileSearchResult
     */
    fileType?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIGuestRequestFileSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIGuestRequestFileSearchResult
     */
    lastModifiedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestFileSearchResult
     */
    guestRequestId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestRequestFileSearchResult
     */
    guestRequestName?: string;
}

/**
 * Check if a given object implements the APIGuestRequestFileSearchResult interface.
 */
export function instanceOfAPIGuestRequestFileSearchResult(value: object): value is APIGuestRequestFileSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIGuestRequestFileSearchResultFromJSON(json: any): APIGuestRequestFileSearchResult {
    return APIGuestRequestFileSearchResultFromJSONTyped(json, false);
}

export function APIGuestRequestFileSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestFileSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'key': json['key'] == null ? undefined : json['key'],
        'fileName': json['file_name'] == null ? undefined : json['file_name'],
        'fileType': json['file_type'] == null ? undefined : json['file_type'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'lastModifiedAt': json['last_modified_at'] == null ? undefined : (new Date(json['last_modified_at'])),
        'guestRequestId': json['guest_request_id'] == null ? undefined : json['guest_request_id'],
        'guestRequestName': json['guest_request_name'] == null ? undefined : json['guest_request_name'],
    };
}

export function APIGuestRequestFileSearchResultToJSON(value?: APIGuestRequestFileSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'key': value['key'],
        'file_name': value['fileName'],
        'file_type': value['fileType'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'last_modified_at': value['lastModifiedAt'] == null ? undefined : ((value['lastModifiedAt'] as any).toISOString()),
        'guest_request_id': value['guestRequestId'],
        'guest_request_name': value['guestRequestName'],
    };
}

